// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"AJ-z","carouselContainer":"BJ-z"};